import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        context: '='
    },
    template: `
        <ul class="actions01">
            <li class="primary">
                <button
                    class="btn main"
                    ng-class="{'loading': vm.loading}"
                    ng-disabled="!vm.courseVersion.courseTrainings.length || vm.loading"
                    ng-click="vm.saveCourse()"
                    >{{ 'general.Save' | translate }}
                </button>
            </li>
            <li ng-if="vm.previewEnabled" class="primary">
                <button ng-disabled="!vm.previewAvailable" class="btn secondary" ng-click="vm.previewModule('coursy')">
                    {{ 'course.materialSource.Preview module' | translate }}
                </button>
            </li>
            <li ng-if="vm.context === 'edit' && !vm.courseVersion.isArchived" class="primary"><button ng-click="vm.archive()" class="btn bordered02">{{ 'general.Archive' | translate }}</button></li>
        </ul>
    `
})
export default class {
    constructor ($q, $scope, $rootScope, MaterialSubmissionResource, TokenService, COURSE_TRAINING_MATERIAL_TYPE_ENUM,
        ModalService, COURSE_TRAINING_TYPE_ENUM, CourseVersionTrainingFormMaterialService, OCCURRENCE_STATUS_ENUM,
        COURSE_PROGRESS_STATUS_TYPE_ENUM, CourseVersionTrainingFormLearndashService, OccurrenceResource, $translate
    ) {
        this.$q = $q;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.MaterialSubmissionResource = MaterialSubmissionResource;
        this.TokenService = TokenService;
        this.COURSE_TRAINING_MATERIAL_TYPE_ENUM = COURSE_TRAINING_MATERIAL_TYPE_ENUM;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.OCCURRENCE_STATUS_ENUM = OCCURRENCE_STATUS_ENUM;
        this.COURSE_PROGRESS_STATUS_TYPE_ENUM = COURSE_PROGRESS_STATUS_TYPE_ENUM;
        this.ModalService = ModalService;
        this.CourseVersionTrainingFormMaterialService = CourseVersionTrainingFormMaterialService;
        this.CourseVersionTrainingFormLearndashService = CourseVersionTrainingFormLearndashService;
        this.OccurrenceResource = OccurrenceResource;
        this.$translate = $translate;

        this.previewAvailable = false; // preview is available for ONLINE course trainings with authoring tools or scorm materials
        this.previewEnabled = true; // preview is enabled only for ONLINE course trainings
        this.selectedCourseTrainingIndex = null;
        this.selectedScormTrainingIndex = null;

        this.defaultLanguage = this.TokenService.getCompanyLanguage();
        this.messages = [];

        $scope.$on('courseVersion:loading', (event, { loading }) => {
            this.loading = loading;
        });

        $scope.$on('versionActions:setCourseVersion', (event, { courseVersion }) => {
            this.courseVersion = courseVersion;
            this.handlePreviewButton();
        });
        $scope.$on('versionActions:setSelectedCourseTrainingIndex', (event, { selectedCourseTrainingIndex }) => {
            this.selectedCourseTrainingIndex = selectedCourseTrainingIndex;
            this.handlePreviewButton();
        });
        $scope.$on('versionActions:setSelectedScormTrainingIndex', (event, { selectedScormTrainingIndex }) => {
            this.selectedScormTrainingIndex = selectedScormTrainingIndex;
            this.handlePreviewButton();
        });
    }

    handlePreviewButton () {
        this.previewEnabled = false;
        this.previewAvailable = false;

        if (this.courseVersion === undefined) {
            return;
        }
        const training = this.courseVersion.courseTrainings ? this.courseVersion.courseTrainings[this.selectedCourseTrainingIndex] : null;

        if (training === undefined || !training) {
            return;
        }

        if (training.type !== this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
            && training.type !== this.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR
            && training.type !== this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM
        ) {
            return;
        }

        this.previewEnabled = true;

        if (training.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_CONTENT
            && training.materials !== undefined && training.materials.length) {
            this.previewAvailable = true;
        }

        if (training.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_SCORM) {
            const scormTraining = this.selectedScormTrainingIndex !== null ? training.scormTrainings[this.selectedScormTrainingIndex] : null;
            if (scormTraining && scormTraining.scorm && scormTraining.scorm.id) {
                this.previewAvailable = true;
            }
        }

        if (training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE
            && training.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.LEARNDASH
            && training.learndashCourseId
            && this.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(training.learndashCourseId)) {
            this.previewAvailable = true;
        }

        if (training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR
            && training.learndashCourseId
            && this.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(training.learndashCourseId)) {
            this.previewAvailable = true;
        }

        if (training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM
            && training.learndashCourseId
            && this.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(training.learndashCourseId)) {
            this.previewAvailable = true;
        }
    }

    saveCourse () {
        this.$rootScope.$broadcast('course:save', { redirect: true });
    }

    previewModule () {
        const training = this.courseVersion.courseTrainings ? this.courseVersion.courseTrainings[this.selectedCourseTrainingIndex] : null;

        if (training.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_CONTENT) {
            this.$rootScope.$broadcast('authoringTool:preview');
            return;
        }
        if (training.materialType === this.COURSE_TRAINING_MATERIAL_TYPE_ENUM.KEYS.COURSY_SCORM) {
            this.$rootScope.$broadcast('scormContent:preview');
            return;
        }
        const href = this.CourseVersionTrainingFormLearndashService.getPreviewLink(training.learndashCourseId);
        window.open(href, '_blank');
    }

    detectArchiveConfirmMessages () {
        const deferred = this.$q.defer();
        const detect = (resolve) => {
            if (!this.courseVersion.courseOccurrences.length) {
                this.messages.push(
                    this.$translate.instant('version.archive.general_confirm_message')
                );
                resolve();
            }
            else {
                const publishedOccurrences = this.courseVersion.courseOccurrences
                    .filter(occurrence => occurrence.status === this.OCCURRENCE_STATUS_ENUM.KEYS.PUBLISHED)
                ;
                if (publishedOccurrences.length) {
                    this.OccurrenceResource.getParticipants(
                        { pageSize: 0, privilegesCheck: 0 },
                        { occurrenceIds: publishedOccurrences.map(occurrence => occurrence.id) }
                    ).$promise.then((participants) => {
                        const notStartedParticipants = participants
                            .some(participant => participant.courseProgressStatus === this.COURSE_PROGRESS_STATUS_TYPE_ENUM.KEYS.NOT_STARTED)
                        ;
                        if (notStartedParticipants) {
                            this.messages.push(
                                this.$translate.instant('version.archive.not_started_participants_message')
                            );
                        }
                        else {
                            this.messages.push(
                                this.$translate.instant('version.archive.general_confirm_message')
                            );
                        }
                        resolve();
                    });
                }
                else {
                    const notPublishedOccurrenceCount = this.courseVersion.courseOccurrences.length - publishedOccurrences.length;
                    this.messages.push(
                        this.$translate.instant('version.archive.related_occurrences_message', { notPublishedOccurrenceCount })
                    );
                    resolve();
                }
            }
        };
        detect(deferred.resolve);
        return deferred.promise;
    }

    archive () {
        this.detectArchiveConfirmMessages().then(() => {
            const { messages, courseVersion } = this;

            return this.ModalService.open({
                template: `
                <modals-courses-version-archive
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    messages="vm.messages"
                    course-version="vm.courseVersion"
                    form="vm.form"
                />
                `,
                controller ($uibModalInstance, lodash, FormFactory) {
                    this.$uibModalInstance = $uibModalInstance;
                    this.messages = lodash.uniq(messages);
                    this.courseVersion = courseVersion;
                    this.form = FormFactory.createFromResource(this.courseVersion, {
                        expand: 'courseTrainings,courseTrainings.scorm,courseTrainingI18ns,courseOccurrences,creator,updater,courseTrainingForms,courseVersionLicences,automatedPlanningGroups'
                    });
                }
            })
            .then(() => {})
            .catch(() => {});
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/actions/version/index.js